import styled from 'styled-components'
import { COLOR } from 'src/service/constant/color'
import select_arrow from 'src/assets/common/select_arrow.png'
import { customMedia } from "src/styles/common/common"

const SelectFormWrap = styled.div`
  > p {
    margin: 0 0 12px 0;
    font-family: NotoSansBold, sans-serif;
    font-size: 18px;
    line-height: 26px;
     ${customMedia.lessThan('tablet')`
       font-size: 16px;
    `}
  }
`

const SelectCustom = styled.select`
  width: 100%;
  height: 56px;
  font-size: 18px;
  line-height: 26px;
  font-family: NotoSansRegular, sans-serif;
  color: ${(props) =>
    props.color === 'active' ? COLOR.black : COLOR.blueGray3};
  border: 1px solid ${COLOR.blueGray2};
  border-radius: 10px;
  margin: 0px auto 24px auto;
  padding-left: 20px;
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  background: url(${select_arrow}) no-repeat 97% 50% / 16px 13px;
  appearance: none;
  &:focus {
    color: black;
    outline: none !important;
    border-color: ${COLOR.point1};
  }
  ${customMedia.lessThan('tablet')`
      font-size: 14px;
      line-height: 40px;

     padding-left: 16px;
      height: 40px;
      line-height: 23px;
      background: url(${select_arrow}) no-repeat 97% 50% / 13px 10px;
   `}

`
const OptionCustom = styled.option``;

export { SelectFormWrap, SelectCustom, OptionCustom };
